import * as React from 'react';

interface IIconCellProps {
  icon?: string;
  isIcon?: boolean;
  tooltip?: string;
  element?: JSX.Element;
}

export default function IconCell(props: IIconCellProps) {
  return (
    <div
      title={props.tooltip}
      className="d-flex align-items-center justify-content-center"
      style={{ flex: 1 }}
    >
      {props.isIcon && <i className={`cmd-icon ${props.icon} fs-4`} />}
      {props.element}
    </div>
  );
}
